const fetchEvents = state => state.events;
const activeEvents = state => state.activeEvents;
const fetchEvent = state => state.event;
const prevEvent = state => state.prevEvent;
const fetchReasonsToAttend = state => state.reasons;
const fetchVenue = state => state.venue;
const fetchVenueCityImages = state => state.venueCityImages;
const fetchKnowledgeSharingSession = state => state.session;
const strategicSponsors = state => state.sponsors;
const parallelEvents = state => state.parallelEvents;
const accommodations = state => state.accommodations;
const speakersList = state => state.speakersList;
const exhibitors = state => state.exhibitors.sort((a, b) => (
  a.position > b.position ? 1 : -1));
const bookedTables = state => state.bookedTables.sort((a, b) => (
  a.position > b.position ? 1 : -1));
const mediaDocs = state => state.mediaDocs;
const meetingRooms = state => state.meetingRooms;
const participantMembers = state => state.participantMembers;
const participantCompanies = state => state.participantCompanies;
const eventPrices = state => state.eventPrices;
const awardPrices = state => state.awardPrices;
const participantMembersCount = state => state.participantMembersCount;
const eventAllSponsors = state => state.eventAllSponsors;

export default {
  fetchEvents,
  activeEvents,
  fetchEvent,
  prevEvent,
  fetchReasonsToAttend,
  fetchVenue,
  fetchVenueCityImages,
  fetchKnowledgeSharingSession,
  strategicSponsors,
  parallelEvents,
  accommodations,
  speakersList,
  exhibitors,
  bookedTables,
  mediaDocs,
  meetingRooms,
  participantMembers,
  participantCompanies,
  eventPrices,
  awardPrices,
  participantMembersCount,
  eventAllSponsors,
};
